export const API_BASE =
    process.env.REACT_APP_API_BASE ?? "https://boxmealadminapinew.azurewebsites.net";

export const BASE_URL =
    "https://boxmealadminapinew.azurewebsites.net/api/ShoppingCart";

export const BASE_URL_UNLOCKER =
    "https://boxmealadminapinew.azurewebsites.net/api/unitunlocker";

const BASE_SETTINGS_URL =
    "https://boxmealadminapinew.azurewebsites.net/api/Settings";

async function handleResponse(response) {
    if (!response.ok) {
        const errorText = await response.text().catch(() => "");
        throw new Error(`HTTP ${response.status} — ${errorText || "Request failed"}`);
    }
    const json = await response.json().catch(() => ({}));
    return json;
}

export async function getSwishPayeeAlias(token) {
    const endpoint = `${BASE_SETTINGS_URL}/get-by-customer`;
    const res = await fetch(endpoint, {
        method: "GET",
        headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
    });
    return handleResponse(res);
}

export async function initiateSwishPaymentApi(paymentData, token) {
    const endpoint = `${BASE_URL}/initiate`;
    const res = await fetch(endpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(paymentData),
    });
    return handleResponse(res);
}

export async function getSwishPaymentStatus(paymentRequestId) {
    const endpoint = `${BASE_URL}/GetSwishPaymentStatus/${encodeURIComponent(paymentRequestId)}`;
    console.debug("[Swish][status] GET:", endpoint);

    const res = await fetch(endpoint, { method: "GET" });

    const bodyPreview = await res.clone().text().catch(() => "(no body)");
    console.debug("[Swish][status] HTTP:", res.status, res.ok ? "OK" : "ERR", "body:", bodyPreview);

    const json = await handleResponse(res);
    console.debug("[Swish][status] JSON:", json);
    return json;
}



export async function getUnlockDetailsApi(fridgeId, userId) {
    const endpoint = `${BASE_URL_UNLOCKER}/getUnlockDetails/${encodeURIComponent(
        fridgeId
    )}?userId=${encodeURIComponent(userId || "guest-user")}`;
    const res = await fetch(endpoint, { method: "GET" });
    return handleResponse(res);
}
